//import { Snippet } from "react-instantsearch-dom"
import { Link } from "gatsby"
import he from "he"
import React from "react"
import { useTranslation } from "react-i18next"

import Image from "@atoms/Image/Image"

//import CustomSnippet from "./CustomSnippet"
import styles from "./Hit.module.scss"

const Hit = ({ hit }) => {
  const { t } = useTranslation()

  const { hostname } = new URL(hit.url)

  const url = hit.url
    .replace(hostname, "")
    .replace("http://", "")
    .replace("https://", "")

  return (
    <div className={styles.allHit}>
      <Link to={url} className={styles.searchHit}>
        {hit.featured_image && (
          <div className={styles.searchHitImage}>
            <Image
              image={
                hit.featured_thumbnail
                  ? hit.featured_thumbnail
                  : hit.featured_image
              }
              widths={[84, 168]}
              fill={true}
            />
          </div>
        )}

        {!hit.featured_image && (
          <div className={styles.searchHitImage}>
            <div style={{ width: 84, height: 84 }} />
          </div>
        )}

        <div className={styles.searchHitContent}>
          <div className={styles.searchHitHeading}>{he.decode(hit.title)}</div>
          <div>
            <div className={styles.searchHitReadMore}>
              <span>{t("Read more")}</span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default Hit
